import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var CardTitle = styled.span.withConfig({
  displayName: "CardTitle",
  componentId: "sc-1eqtksf-0"
})(["display:flex;flex-flow:column;", ";font-weight:600;color:currentColor;&:hover{color:", ";}"], getFont(0, 'compact'), function (_ref) {
  var theme = _ref.theme;
  return theme.linkColor;
});